const $ = require('jquery');

const setupContactFormAccessibility = () => {
  $(document).ready(() => {
    $('.wpcf7-form').attr('aria-hidden', 'true');
  });
}

module.exports = setupContactFormAccessibility;
